import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  CompanyAddApi,
} from "../../Utils/Axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toInputUpperCase } from "../../Utils/Validate";


const AnonymouseCmpRegistration = () => {
  const {
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({ mode: "onChange" });
  const companyType = watch("companyType", "");
  const watchedIndustry = watch("industry");
  const [editMode, setEditMode] = useState(false); // State to track edit mode
  const [errorMessage, setErrorMessage] = useState("");
  const watchRegistrationNumber = watch("cinNo", "");

  const [branches, setBranches] = useState([
    {
      branchName: "",
      mobileNo: "+91 ",
      alternateNo: "+91 ",
      emailId: "",
      gstNo: "",
      branchAddress: "",
      branchType: "",
    },
  ]);

  const navigate = useNavigate();

  const handleAddBranch = () => {
    setBranches([
      ...branches,
      {
        branchName: "",
        mobileNo: "+91 ",
        alternateNo: "+91 ",
        emailId: "",
        gstNo: "",
        branchAddress: "",
        branchType: "",
      },
    ]);
  };

  const handleRemoveBranch = (index) => {
    if (branches.length > 1) {
      const updatedBranches = [...branches];
      updatedBranches.splice(index, 1);
      setBranches(updatedBranches);
    } else {
      toast.warning("At least one branch is required.");
    }
  };

  const handleBranchChange = (index, field, value) => {
    const updatedBranches = [...branches];
    if (field === "mobileNo" || field === "alternateNo") {
      // Ensure +91 prefix
      if (!value.startsWith("+91")) {
        value = "+91 ";
      }
      if (value.startsWith("+91") && value.charAt(3) !== " ") {
        value = "+91 " + value.slice(3);
      }
      const numericValue = value.slice(4).replace(/[^0-9]/g, "");
      value = "+91 " + numericValue;
      if (value.length > 14) {
        value = value.slice(0, 14);
      }
    }
    updatedBranches[index][field] = value;
    setBranches(updatedBranches);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;

    // Prevent space key (keyCode 32) from being entered
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  const handleCompanyTypeChange = (e) => {
    // Relying on RHF watch instead of state
  };

  const onSubmit = async (data) => {
    try {
      const validBranches = branches.filter(
        (b) => b.branchName.trim() !== "" && b.emailId.trim() !== ""
      ).map(b => ({
        ...b,
        alternateNo: b.alternateNo && b.alternateNo.trim() !== "+91" ? b.alternateNo : null
      }));

      const payload = {
        ...data, // spread all values from form
        alternateNo: data.alternateNo,
        websiteUrl: data.websiteUrl || null,
        industry: data.industry === "Other" ? (data.industryOther || data.industry) : data.industry,
        legalCompanyName: data.legalCompanyName || null,
        branches: validBranches,
      };
      await CompanyAddApi(payload);
      toast.success("Company Created Successfully")
      navigate("/");
      reset();
    } catch (error) {
      console.log("Entered catch block"); // Add this line
      console.log("Full error object:", error);
      let errorList = [];

      // Check if error response exists
      if (error.response) {
        // Case 1: General error message
        if (error.response.data.error && error.response.data.error.message) {
          const generalErrorMessage = error.response.data.error.message;
          // toast.error("Invalid Format");  // Display general error message
          errorList.push(generalErrorMessage);
        }

        // Case 2: Specific error messages (multiple messages, such as form validation errors)
        if (error.response.data.error && error.response.data.error.messages) {
          const specificErrorMessages = error.response.data.error.messages;
          // toast.error("Invalid Format Fields");
          specificErrorMessages.forEach((message) => {
            // Display each error message individually
            errorList.push(message);
          });
        }

        // Case 3: Specific error data (duplicate value conflicts)
        if (error.response.data.data) {
          const conflictData = error.response.data.data;
          let conflictMessage = "Error Details:\n";
          toast.error(error.response.data.message);
          // Check if data contains specific conflict details (e.g., duplicate values)
          Object.keys(conflictData).forEach((key) => {
            const value = conflictData[key];
            conflictMessage += `${key}: ${value}\n`;
          });

          // Display detailed conflict message in toast and add to error list
          errorList.push(conflictMessage);
        }

        // Handle HTTP 409 Conflict Error (duplicate or other conflicts)
        if (error.response.status === 409) {
          const conflictMessage =
            error.response.data.message || "A conflict occurred.";
          // toast.error(conflictMessage);  // Show conflict error in toast
        }
      } else {
        // General error (non-Axios)
        console.log("Error without response:", error);
        toast.error("An unexpected error occurred. Please try again later.");
      }

      // Update the error messages in the state
      setErrorMessage(errorList);
    }
  };


  const clearForm = () => {
    setBranches([
      {
        branchName: "",
        mobileNo: "",
        alternateNo: "",
        emailId: "",
        gstNo: "",
        branchAddress: "",
        branchType: "",
      },
    ]);
    reset();
    // setEditMode(true);  // Optionally, if you want to reset edit mode
  };
  const backForm = () => {
    setBranches([
      {
        branchName: "",
        mobileNo: "",
        alternateNo: "",
        emailId: "",
        gstNo: "",
        branchAddress: "",
        branchType: "",
      },
    ]);
    reset();
    navigate("/")
    // setEditMode(true);  // Optionally, if you want to reset edit mode
  };

  const toInputTitleCase = (e) => {
    const input = e.target;
    let value = input.value;
    const cursorPosition = input.selectionStart; // Save the cursor position

    // Remove leading spaces
    value = value.replace(/^\s+/g, "");

    // Ensure only allowed characters (alphabets, numbers, and some special chars)
    const allowedCharsRegex = /^[a-zA-Z0-9\s!@#&()*/,.\\-]+$/;
    value = value
      .split("")
      .filter((char) => allowedCharsRegex.test(char))
      .join("");

    // Capitalize the first letter of each word
    const words = value.split(" ");

    // Capitalize the first letter of each word and leave the rest of the characters as they are
    const capitalizedWords = words.map((word) => {
      if (word.length > 0) {
        // Capitalize the first letter, keep the rest as is
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return "";
    });

    // Join the words back into a string
    let formattedValue = capitalizedWords.join(" ");

    // Remove spaces not allowed (before the first two characters)
    if (formattedValue.length > 3) {
      formattedValue =
        formattedValue.slice(0, 3) +
        formattedValue.slice(3).replace(/\s+/g, " ");
    }

    // Update input value
    input.value = formattedValue;

    // Restore the cursor position
    input.setSelectionRange(cursorPosition, cursorPosition);
  };

  const validatePassword = (value) => {
    const errors = [];
    if (!/(?=.*[0-9])/.test(value)) {
      errors.push("at least one digit");
    }
    if (!/(?=.*[a-z])/.test(value)) {
      errors.push("at least one lowercase letter");
    }
    if (!/(?=.*[A-Z])/.test(value)) {
      errors.push("at least one uppercase letter");
    }
    if (!/(?=.*[\W_])/.test(value)) {
      errors.push("at least one special character");
    }
    if (errors.length > 0) {
      return `Password must contain ${errors.join(", ")}.`;
    }
    return true; // Return true if all conditions are satisfied
  };

  const toInputLowerCase = (e) => {
    const input = e.target;
    let value = input.value;

    // Remove all spaces
    value = value.replace(/\s+/g, "");

    // Convert the entire string to lowercase
    value = value.toLowerCase();

    // Update input value
    input.value = value;
  };
  const toInputSpaceCase = (e) => {
    let inputValue = e.target.value;
    let newValue = "";

    // Remove spaces from the beginning of inputValue
    inputValue = inputValue.trimStart(); // Keep spaces only after the initial non-space character

    // Track if we've encountered any non-space character yet
    let encounteredNonSpace = false;

    for (let i = 0; i < inputValue.length; i++) {
      const char = inputValue.charAt(i);

      // Allow any alphabetic characters (both lowercase and uppercase) and numbers
      // Allow spaces only after encountering non-space characters
      if (char.match(/[a-zA-Z0-9]/) || (encounteredNonSpace && char === " ")) {
        if (char !== " ") {
          encounteredNonSpace = true;
        }
        newValue += char;
      }
    }

    // Update the input value
    e.target.value = newValue;
  };




  const validateREGISTER = (value) => {
    const spaceError = "Spaces are not allowed in the Register Number.";
    const patternError = "Invalid Register Number format";

    if (/\s/.test(value)) {
      return spaceError; // Return space error if spaces are found
    }

    // Check the pattern for the CIN Number
    if (
      !/^([LU]{1})([0-9]{5})([A-Z]{2})([0-9]{4})([A-Z]{3})([0-9]{6})$/.test(
        value
      )
    ) {
      return patternError; // Return pattern error if it doesn't match
    }

    return true; // Return true if all checks pass
  };

  const handlePaste = (e) => {
    const pastedText = e.clipboardData.getData('Text');
    const sanitizedText = pastedText.replace(/[^A-Za-z0-9]/g, ''); // Keep only alphanumeric characters
    e.preventDefault(); // Prevent the default paste action
    e.target.value = sanitizedText; // Insert the sanitized text back into the input
  };

  const validateCIN = (value) => {
    const spaceError = "Spaces are not allowed in the CIN Number.";
    const patternError = "Invalid CIN Number format";

    if (/\s/.test(value)) {
      return spaceError; // Return space error if spaces are found
    }

    // Check the pattern for the CIN Number
    if (
      !/^([LU]{1})([0-9]{5})([A-Z]{2})([0-9]{4})([A-Z]{3})([0-9]{6})$/.test(
        value
      )
    ) {
      return patternError; // Return pattern error if it doesn't match
    }

    return true; // Return true if all checks pass
  };

  const validateGST = (value) => {
    const spaceError = "Spaces are not allowed in the GST Number.";
    const patternError = "Invalid GST Number format";

    if (!value) {
      return true;
    }

    if (/\s/.test(value)) {
      return spaceError; // Return space error if spaces are found
    }

    // Check the pattern for the CIN Number
    if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[0-9A-Z]{1}$/.test(value)) {
      return patternError; // Return pattern error if it doesn't match
    }

    return true; // Return true if all checks pass
  };

  const validateName = (value) => {
    // Trim leading and trailing spaces
    const trimmedValue = value.trim();

    // Check for leading or trailing spaces
    if (/^\s/.test(value)) {
      return "Leading space not allowed."; // Leading space error
    } else if (/\s$/.test(value)) {
      return "Spaces at the end are not allowed."; // Trailing space error
    }

    // Check for multiple spaces between words
    if (/\s{2,}/.test(value)) {
      return "No Multiple Spaces Between Words Allowed.";
    }

    // Validate special characters and alphabets (including @, $, &, ())
    const validCharsRegex = /^[A-Za-z\s,.'\-/&@$()]*$/;
    if (!validCharsRegex.test(value)) {
      return "Field accepts only alphabets and special characters: ( , ' - . / & @ $ ( ) )";
    }

    // Check word lengths (min 2 characters for alphabetic words)
    const words = trimmedValue.split(" ");

    for (const word of words) {
      // Allow words that are only special characters (e.g., "-")
      if (/^[\W]+$/.test(word)) {
        continue; // Skip special characters only words
      }

      // If the word contains special characters (e.g., "dsad-@dsad"), it is valid
      // Ensure at least 2 alphabetic characters before any special characters in a word
      if (/^[A-Za-z]+[\W]*[A-Za-z]*$/.test(word)) {
        continue; // Word contains at least 2 alphabetic characters with or without special characters
      }

      // If the word is alphabetic and has less than 2 characters, show error
      if (/^[A-Za-z]+$/.test(word) && word.length < 2) {
        return "Minimum Length 2 Characters Required."; // If any alphabetic word is shorter than 2 characters
      }

      // If the word exceeds 100 characters, show error
      if (word.length > 100) {
        return "Max Length 100 Characters Exceed."; // If any word is longer than 100 characters
      }
    }

    return true; // Return true if all conditions are satisfied
  };



  const validatePAN = (value) => {
    const spaceError = "Spaces are not allowed in the PAN Number.";
    const patternError = "Invalid PAN Number format";

    if (/\s/.test(value)) {
      return spaceError; // Return space error if spaces are found
    }

    // Check the pattern for the CIN Number
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
      return patternError; // Return pattern error if it doesn't match
    }

    return true; // Return true if all checks pass
  };

  function handlePhoneNumberChange(event) {
    let value = event.target.value;

    // Ensure the value starts with +91 and one space
    if (value.startsWith("+91") && value.charAt(3) !== " ") {
      value = "+91 " + value.slice(3); // Ensure one space after +91
    }

    // Allow only numeric characters after +91 and the space
    const numericValue = value.slice(4).replace(/[^0-9]/g, ""); // Remove any non-numeric characters after +91
    if (numericValue.length <= 10) {
      value = "+91 " + numericValue; // Keep the +91 with a space
    }

    // Limit the total length to 14 characters (including +91 space)
    if (value.length > 14) {
      value = value.slice(0, 14); // Truncate if the length exceeds 14 characters
    }

    // Update the input field's value
    event.target.value = value;
  }

  return (
    <div className="container-fluid " >
      <div className="row d-flex align-items-center justify-content-between mt-1 mb-2">
        <div className="col" style={{ marginLeft: "100px", marginRight: "100px", marginTop: "40px" }}>
          <h1 className="h3 mb-3 text-base text-primary">
            Fill out the details below to create your account and get started with hassle-free HR management—built
            for small and growing teams like yours.
          </h1>
          <span className="text-info"></span>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12">
            <div className="card" style={{ marginLeft: "100px", marginRight: "100px" }}>
              <div className="card-header ">
                <div className="d-flex justify-content-start align-items-start">
                  <h5 className="card-title" style={{ marginBottom: "0px" }}>
                    Company Type
                  </h5>
                  <span
                    className="text-danger"
                    style={{ marginLeft: "10px" }}
                  >
                    {errors.companyType && (
                      <p className="mb-0">{errors.companyType.message}</p>
                    )}
                  </span>
                </div>
                <hr
                  className="dropdown-divider"
                  style={{ borderTopColor: "#d7d9dd", width: "100%" }}
                />
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <div>
                      <label>
                        <input
                          type="radio"
                          name="companyType"
                          value="Private Limited"
                          style={{ marginRight: "10px" }}
                          {...register("companyType", {
                            required: !editMode
                              ? "Please Select Your Company Type"
                              : false,
                            onChange: handleCompanyTypeChange, // Merge the onChange into RHF
                          })}
                          disabled={editMode}
                        />
                        Private Limited
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="ml-3">
                      <input
                        type="radio"
                        name="companyType"
                        value="Firm"
                        style={{ marginRight: "10px" }}
                        {...register("companyType", {
                          required: !editMode
                            ? "Please Select Your Company Type"
                            : false,
                          onChange: handleCompanyTypeChange, // Merge the onChange into RHF
                        })}
                        disabled={editMode}
                      />
                      Firm
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: "90px", marginRight: "90px" }}>
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title" style={{ marginBottom: "0px" }}>
                  Company Details
                </h5>
                <div
                  className="dropdown-divider"
                  style={{ borderTopColor: "#d7d9dd" }}
                />
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Company Name <span style={{ color: "red" }}>*</span>{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Company Name"
                      onInput={toInputTitleCase}
                      autoComplete="off"
                      {...register("companyName", {
                        required: "Company Name is Required",
                        validate: {
                          validateName,
                        },
                        minLength: {
                          value: 2,
                          message: "Minimum 2 Characters Required",
                        },
                        maxLength: {
                          value: 200,
                          message: "Maximum 200 Characters Required",
                        },
                      })}
                      disabled={editMode}
                    />
                    {errors.companyName && (
                      <p className="errorMsg">{errors.companyName.message}</p>
                    )}
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Service Name (Short Name) <span style={{ color: "red" }}>*</span>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={
                          <Tooltip className="p-2 shadow-sm border-0" style={{ minWidth: "200px", backgroundColor: '#000' }}>
                            <p className="mb-0 small text-white fw-semibold">
                              Remember this service name for future reference
                            </p>
                          </Tooltip>
                        }
                      >
                        <span className="ms-2" style={{ cursor: "pointer" }}>
                          <i className="bi bi-info-circle text-primary"></i>
                        </span>
                      </OverlayTrigger>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      onInput={toInputLowerCase}
                      placeholder="Enter Service Name"
                      autoComplete="off"
                      {...register("shortName", {
                        required: "Service Name is Required",
                        pattern: {
                          value: /^[a-zA-Z]+$/,
                          message:
                            "No Spaces allowed. These fields only accept small cases only.",
                        },
                        minLength: {
                          value: 2,
                          message: "Minimum 2 Characters Required",
                        },
                        maxLength: {
                          value: 30,
                          message:
                            "Minimum 2 and Maximum 30 Characters allowed",
                        },
                      })}
                      disabled={editMode}
                    />
                    {errors.shortName && (
                      <p className="errorMsg">{errors.shortName.message}</p>
                    )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Legal Company Name <span style={{ color: "red" }}>*</span>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={
                          <Tooltip className="p-2 shadow-sm border-0" style={{ minWidth: "220px", backgroundColor: '#000' }}>
                            <p className="mb-0 small text-white fw-semibold">
                              As per Government Registration
                            </p>
                          </Tooltip>
                        }
                      >
                        <span className="ms-2" style={{ cursor: "pointer" }}>
                          <i className="bi bi-info-circle text-primary"></i>
                        </span>
                      </OverlayTrigger>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Legal Company Name"
                      onInput={toInputTitleCase}
                      autoComplete="off"
                      {...register("legalCompanyName", {
                        required: "Legal Company Name is Required",
                        minLength: { value: 2, message: "Minimum 2 Characters Required" },
                        maxLength: { value: 200, message: "Maximum 200 Characters Required" },
                        validate: { validateName },
                      })}
                    />
                    {errors.legalCompanyName && (
                      <p className="errorMsg">{errors.legalCompanyName.message}</p>
                    )}
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Company Email Id <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Company Email Id"
                      autoComplete="off"
                      //onInput={toInputEmailCase}
                      onKeyDown={handleEmailChange}
                      onPaste={handlePaste}
                      {...register("emailId", {
                        required: "Company Email Id is Required",
                        pattern: {
                          value:
                            /^[a-z][a-zA-Z0-9._+-]*@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov)$/,
                          message: "Invalid email format",
                        },
                      })}
                      disabled={editMode}
                    />
                    {errors.emailId && (
                      <p className="errorMsg">{errors.emailId.message}</p>
                    )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Mobile Number{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Enter Mobile Number"
                      autoComplete="off"
                      maxLength={14} // Limit input to 14 characters (3 for +91, 1 for space, 10 for digits)
                      defaultValue="+91 " // Set the initial value to +91 with a space
                      onInput={handlePhoneNumberChange} // Handle input changes
                      {...register("mobileNo", {
                        required: "Mobile Number is Required",
                        validate: {
                          startsWithPlus91: (value) => {
                            if (!value.startsWith("+91 ")) {
                              return "Mobile Number must start with +91.";
                            }
                            return true;
                          },
                          correctLength: (value) => {
                            if (value.length !== 14) {
                              return "Mobile Number is Required";
                            }
                            return true;
                          },
                          notRepeatingDigits: (value) => {
                            const isRepeating = /^(\d)\1{12}$/.test(
                              value
                            ); // Check for repeating digits
                            return (
                              !isRepeating ||
                              "Mobile Number cannot consist of the same digit repeated."
                            );
                          },
                        },
                        pattern: {
                          value: /^\+91\s[6-9]\d{9}$/, // Ensure it starts with +91, followed by a space, and then 6-9 and 9 more digits
                          message: "Mobile Number is Required",
                        },
                      })}
                    />
                    {errors.mobileNo && (
                      <p className="errorMsg">
                        {errors.mobileNo.message}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-2">
                    <label className="form-label">
                      Alternate Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Enter Alternate Number"
                      autoComplete="off"
                      maxLength={14}
                      defaultValue="+91 " // Set the initial value to +91 with a space
                      onInput={handlePhoneNumberChange} // Handle input changes
                      // onKeyDown={handlePhoneNumberKeyDown} // Handle keydown for specific actions
                      {...register("alternateNo", {
                        required: "Alternate Number is Required",
                        validate: {
                          startsWithPlus91: (value) => {
                            if (!value.startsWith("+91 ")) {
                              return "Alternate Number must start with +91 and a space.";
                            }
                            return true;
                          },
                          correctLength: (value) => {
                            if (value.length !== 14) {
                              return "Alternate Number must be 10 digits";
                            }
                            return true;
                          },
                          notRepeatingDigits: (value) => {
                            const isRepeating = /^(\d)\1{12}$/.test(value);
                            return (
                              !isRepeating ||
                              "Alternate Number cannot consist of the same digit repeated."
                            );
                          },
                        },
                        pattern: {
                          value: /^\+91\s[6-9]\d{9}$/,
                          message: "Invalid Alternate Number format",
                        },
                      })}
                    />
                    {errors.alternateNo && (
                      <p className="errorMsg">{errors.alternateNo.message}</p>
                    )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">Website URL</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="https://www.company.com"
                      autoComplete="off"
                      {...register("websiteUrl", {
                        validate: (value) => {
                          if (!value || value.trim() === "") return true;
                          const pattern =
                            /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}\.?(\/.*)?$/;
                          return (
                            pattern.test(value.trim()) ||
                            "Enter a valid URL (e.g., https://www.company.com or www.company.com)"
                          );
                        },
                      })}
                    />
                    {errors.websiteUrl && (
                      <p className="errorMsg">{errors.websiteUrl.message}</p>
                    )}
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Industry <span style={{ color: "red" }}>*</span>
                    </label>
                    {watchedIndustry !== "Other" ? (
                      <select
                        className="form-select"
                        {...register("industry", { required: "Industry is Required" })}
                      >
                        <option value="">Select Industry</option>
                        <option value="Information Technology">Information Technology</option>
                        <option value="Healthcare">Healthcare</option>
                        <option value="Finance & Banking">Finance &amp; Banking</option>
                        <option value="Manufacturing">Manufacturing</option>
                        <option value="Retail & E-commerce">Retail &amp; E-commerce</option>
                        <option value="Education">Education</option>
                        <option value="Logistics & Supply Chain">Logistics &amp; Supply Chain</option>
                        <option value="Construction & Real Estate">Construction &amp; Real Estate</option>
                        <option value="Hospitality & Travel">Hospitality &amp; Travel</option>
                        <option value="Consulting & Professional Services">Consulting &amp; Professional Services</option>
                        <option value="Other">Other</option>
                      </select>
                    ) : (
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Please specify your industry"
                          autoComplete="off"
                          autoFocus
                          {...register("industryOther", { required: "Please specify your industry" })}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setValue("industry", "")}
                          title="Back to list"
                        >
                          ✕
                        </button>
                      </div>
                    )}
                    {errors.industry && (
                      <p className="errorMsg">{errors.industry.message}</p>
                    )}
                    {watchedIndustry === "Other" && errors.industryOther && (
                      <p className="errorMsg">{errors.industryOther.message}</p>
                    )}
                  </div>
                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Employee Count <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("employeeCount", { required: "Employee Count is Required" })}
                    >
                      <option value="">Select Employee Count</option>
                      <option value="1-10">1–10</option>
                      <option value="11-50">11–50</option>
                      <option value="51-200">51–200</option>
                      <option value="201-500">201–500</option>
                      <option value="501-1000">501–1000</option>
                      <option value="1001-5000">1001–5000</option>
                      <option value="5000+">5000+</option>
                    </select>
                    {errors.employeeCount && (
                      <p className="errorMsg">{errors.employeeCount.message}</p>
                    )}
                  </div>
                  <div className="col-lg-1"></div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: "90px", marginRight: "90px" }}>
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title" style={{ marginBottom: "0px" }}>
                  Company Registration Details
                </h5>
                <div
                  className="dropdown-divider"
                  style={{ borderTopColor: "#d7d9dd" }}
                />
              </div>
              <div className="card-body">
                <div className="row">
                  {(companyType === "Private Limited" || !companyType) && (
                    <>
                      <div className="col-12 col-md-6 col-lg-5 mb-3">
                        <label className="form-label">
                          Company CIN Number
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Company CIN Number"
                          onKeyDown={handleEmailChange}
                          onInput={(e) => {
                            toInputSpaceCase(e);
                            toInputUpperCase(e);
                          }}
                          autoComplete="off"
                          maxLength={21}
                          onPaste={handlePaste}
                          {...register("cinNo", {
                            required: (companyType === "Private Limited" || !companyType) ? "Company CIN Number is Required" : false,
                            maxLength: {
                              value: 21,
                              message: "CIN Number must not exceed 21 characters",
                            },
                            validate: validateCIN
                          })}
                          disabled={editMode}
                        />
                        {errors.cinNo && (
                          <p className="errorMsg">{errors.cinNo.message}</p>
                        )}
                      </div>
                      <div className="col-lg-1"></div>
                    </>
                  )}

                  {companyType === "Firm" && (
                    <>
                      <div className="col-12 col-md-6 col-lg-5 mb-3">
                        <label className="form-label">
                          Company Registration Number{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Company Registration Number"
                          autoComplete="off"
                          maxLength={21}
                          onPaste={handlePaste}
                          {...register("companyRegNo", {
                            required: "Company Registration Number is Required",
                            maxLength: {
                              value: 21,
                              message: "Registration Number must not exceed 21 characters",
                            },
                            validate: validateREGISTER
                          })}
                          disabled={editMode}
                        />
                        {errors.companyRegNo && (
                          <p className="errorMsg">
                            {errors.companyRegNo.message}
                          </p>
                        )}
                      </div>
                      <div className="col-lg-1"></div>
                    </>
                  )}


                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Company PAN Number{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      onInput={(e) => {
                        toInputSpaceCase(e);
                        toInputUpperCase(e);
                      }}
                      placeholder="Enter Company PAN Number"
                      autoComplete="off"
                      onKeyDown={handleEmailChange}
                      onPaste={handlePaste}
                      maxLength={10}
                      {...register("panNo", {
                        required: "Company PAN Number is Required",
                        maxLength: {
                          value: 10,
                          message: "PAN Number must not exceed 10 characters",
                        },
                        validate: validatePAN,
                      })}
                      disabled={editMode}
                    />
                    {errors.panNo && (
                      <p className="errorMsg">{errors.panNo.message}</p>
                    )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3 d-flex align-items-center">
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="defaultSetup"
                        {...register("defaultSetup")}
                        disabled={editMode}
                      />
                      <label className="form-check-label ms-2" htmlFor="defaultSetup">
                        Default Settings
                      </label>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={
                          <Tooltip className="p-2 shadow-sm border-0" style={{ minWidth: "250px", backgroundColor: '#000' }}>
                            <p className="mb-0 small text-white fw-semibold">
                              Enabling this will pre-configure:
                              <br />• Tax and other settings are applied to the company
                              <br />• Salary Templates
                              <br />• TDS Settings
                              <br />• Salary Structures
                              <br />• Company Calendar
                            </p>
                          </Tooltip>
                        }
                      >
                        <span className="ms-2" style={{ cursor: "pointer" }}>
                          <i className="bi bi-info-circle text-primary"></i>
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: "90px", marginRight: "90px" }}>
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title" style={{ marginBottom: "0px" }}>
                  Authorized Details
                </h5>
                <div
                  className="dropdown-divider"
                  style={{ borderTopColor: "#d7d9dd" }}
                />
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      // onKeyDown={handleEmailChange}
                      onInput={toInputTitleCase}
                      autoComplete="off"
                      {...register("name", {
                        required: "Name is Required",
                        minLength: {
                          value: 3,
                          message: "Minimum 3 characters Required",
                        },
                        maxLength: {
                          value: 100,
                          message: "Name must not exceed 100 characters",
                        },
                        validate: {
                          validateName,
                        },
                      })}
                    />
                    {errors.name && (
                      <p className="errorMsg">{errors.name.message}</p>
                    )}
                  </div>

                  <div className="col-lg-1"></div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Personal Email Id{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Personal Email Id"
                      autoComplete="off"
                      // onInput={toInputEmailCase}
                      onPaste={handlePaste}
                      onKeyDown={handleEmailChange}
                      {...register("personalMailId", {
                        required: "Personal Email Id is Required",
                        pattern: {
                          value:
                            /^[a-z][a-zA-Z0-9._+-]*@[a-zA-Z0-9.-]+\.(com|in|org|net|edu|gov)$/,
                          message: "Invalid Email Format ",
                        },
                      })}
                    />
                    {errors.personalMailId && (
                      <p className="errorMsg">
                        {errors.personalMailId.message}
                      </p>
                    )}
                  </div>
                  <div className="col-12 col-md-6 col-lg-5 mb-3">
                    <label className="form-label">
                      Personal Mobile Number{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Enter Personal Mobile Number"
                      autoComplete="off"
                      maxLength={14}
                      defaultValue="+91 " // Set the initial value to +91 with a space
                      onInput={handlePhoneNumberChange} // Handle input changes
                      // onKeyDown={handlePhoneNumberKeyDown} // Handle keydown for specific actions
                      {...register("personalMobileNo", {
                        required: "Personal Mobile Number is Required",
                        validate: {
                          startsWithPlus91: (value) => {
                            if (!value.startsWith("+91 ")) {
                              return "Personal Mobile Number must start with +91 and a space.";
                            }
                            return true;
                          },
                          correctLength: (value) => {
                            if (value.length !== 14) {
                              return "Personal Mobile Number is Required";
                            }
                            return true;
                          },
                          notRepeatingDigits: (value) => {
                            const isRepeating = /^(\d)\1{12}$/.test(value); // Check for repeating digits
                            return (
                              !isRepeating ||
                              "Personal Mobile Number cannot consist of the same digit repeated."
                            );
                          },
                        },
                        pattern: {
                          value: /^\+91\s[6-9]\d{9}$/, // Ensure it starts with +91, followed by a space, and then 6-9 and 9 more digits
                          message: "Personal Mobile Number is Required",
                        },
                      })}
                    />
                    {errors.personalMobileNo && (
                      <p className="errorMsg">
                        {errors.personalMobileNo.message}
                      </p>
                    )}
                  </div>

                  <div className="col-lg-1"></div>

                  {/* Personal Address */}
                  <div className="col-12 mb-3">
                    <label className="form-label">
                      Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Address"
                      rows={2}
                      autoComplete="off"
                      {...register("address", {
                        required: "Address is Required",
                      })}
                    />
                    {errors.address && (
                      <p className="errorMsg">{errors.address.message}</p>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: "90px", marginRight: "90px" }}>
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="card-title" style={{ marginBottom: "0px" }}>
                  Branch Details
                </h5>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={handleAddBranch}
                >
                  <i className="bi bi-plus-lg me-1"></i> Add Branch
                </button>
              </div>
              <div className="card-body">
                {branches.map((branch, index) => (
                  <div key={index} className="position-relative border rounded p-3 mb-3">
                    {/* Remove Branch Button */}
                    {branches.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-link text-danger position-absolute top-0 end-0 mt-2 me-2 p-0"
                        onClick={() => handleRemoveBranch(index)}
                        title="Remove Branch"
                      >
                        <i className="bi bi-x-circle fs-5"></i>
                      </button>
                    )}

                    <div className="row">
                      {/* Branch Name */}
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Branch Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Branch Name"
                          value={branch.branchName}
                          onChange={(e) => handleBranchChange(index, "branchName", e.target.value)}
                          autoComplete="off"
                        />
                      </div>

                      {/* Branch Mobile Number */}
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Branch Mobile No
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="+91 9XXXXXXXXX"
                          maxLength={14}
                          value={branch.mobileNo || "+91 "}
                          onChange={(e) => handleBranchChange(index, "mobileNo", e.target.value)}
                          autoComplete="off"
                        />
                      </div>

                      {/* Branch Alternate Number */}
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Branch Alternate No
                        </label>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="+91 9XXXXXXXXX (Optional)"
                          maxLength={14}
                          value={branch.alternateNo || "+91 "}
                          onChange={(e) => handleBranchChange(index, "alternateNo", e.target.value)}
                          autoComplete="off"
                        />
                      </div>

                      {/* Communication Mail */}
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Communication Mail <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Communication Mail"
                          value={branch.emailId}
                          onChange={(e) => handleBranchChange(index, "emailId", e.target.value)}
                          autoComplete="off"
                        />
                      </div>

                      {/* Branch GST */}
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Branch GST No
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GST Number"
                          maxLength={15}
                          onInput={(e) => {
                            toInputSpaceCase(e);
                            toInputUpperCase(e);
                          }}
                          value={branch.gstNo || ""}
                          onChange={(e) => handleBranchChange(index, "gstNo", e.target.value.toUpperCase())}
                          autoComplete="off"
                        />
                      </div>

                      {/* Branch Type */}
                      <div className="col-12 col-md-6 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Branch Type
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. Sales, Manufacturing, etc."
                          value={branch.branchType || ""}
                          onChange={(e) => handleBranchChange(index, "branchType", e.target.value)}
                          autoComplete="off"
                        />
                      </div>

                      {/* Branch Address */}
                      <div className="col-12 mb-3">
                        <label className="form-label fw-medium text-dark small">
                          Branch Address
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Enter Branch Address"
                          rows={2}
                          value={branch.branchAddress}
                          onChange={(e) => handleBranchChange(index, "branchAddress", e.target.value)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-1"></div>
        <div className="col-12 mt-1">
          {/* Display error message above the button if there are any error messages */}
          {errorMessage.length > 0 && (
            <div className="alert alert-danger text-center mt-1">
              {errorMessage.map((msg, index) => (
                <p key={index}>{msg}</p> // Display each message in a <p> tag
              ))}
            </div>
          )}

          <div className="d-flex justify-content-end mt-1">
            {/* Conditionally render the "Clear" button only when not in editMode */}
            {!editMode ? (
              <button
                className="btn btn-secondary me-2"
                type="button"
                onClick={clearForm}
              >
                Clear
              </button>
            ) : (
              <button
                className="btn btn-secondary me-2"
                type="button"
                onClick={backForm}
              >
                Back
              </button>
            )}

            <button
              className={
                editMode ? "btn btn-danger btn-lg" : "btn btn-primary btn-lg"
              }
              style={{ marginRight: "85px" }}
              type="submit"
            >
              {editMode ? "Update Company" : "Add Company"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AnonymouseCmpRegistration;
